import styled, { css } from 'styled-components'
import { Roboto_num2_b16 } from 'src/styles/font/RobotoFonts'
import { Noto_body1_b16, Noto_body2_b14, Noto_body2_r14 } from 'src/styles/font/NotoSansKrFonts'
import checkboxBg from 'src/assets/images/icon/icon-check.svg'

export const DefaultFormStyle = {
  DefaultFormContainer: styled.div`
    max-width: 492px;
    width: 100%;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    gap: 10px;
  `,
  CertFormContainer: styled.form<{ $mainBg: string }>`
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 0 20px;
    background-color: ${(props) => props.$mainBg || 'white'};
  `,
  CertFormContents: styled.div<{ $gap?: string }>`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: ${(props) => (props.$gap === 'interval' ? '10px' : 0)};
  `,
  CertInputStyle: ({
    backgroundColor,
    borderColor,
    touch,
  }: {
    backgroundColor?: string
    borderColor?: string
    touch?: boolean
  }) => css`
    ${!touch &&
    css`
      background-color: ${backgroundColor || 'white'};
    `}
    &:focus {
      background-color: ${backgroundColor || 'white'};
      border: 1.5px solid ${borderColor};
    }
  `,
  OtpFormContainer: styled.div`
    width: 100%;
    display: flex;
    gap: 6px;
    position: relative;
  `,
  ApprovalNumberContainer: styled.div`
    width: 100%;
    display: flex;
    flex-flow: column;
    align-items: flex-start;
  `,
  ApprovalNumberInputWrap: styled.div`
    width: 100%;
    position: relative;
  `,
  Timer: styled.div`
    ${Roboto_num2_b16};
    color: var(--black-50);
    position: absolute;
    top: 49%;
    transform: translate(0, -50%);
    right: 75px;
  `,
  RetryRequestButton: css`
    width: fit-content;
    border-radius: 5px;
    position: absolute;
    right: 16px;
    border: none;
    background-color: transparent;
    color: var(--black-100);
  `,
  JoinTermsWrap: styled.div`
    width: 100%;
    display: flex;
    flex-flow: column;
    gap: 10px;
    padding: 10px 0;
    border-bottom: 1px solid rgb(211, 215, 228);
  `,

  JoinTermsOpenDesc: styled.button.attrs({ type: 'button' })`
    ${Noto_body2_b14};
    color: var(--black-50);
    text-decoration: underline;
    flex-shrink: 0;
  `,
  JoinTermsItem: styled.div<{ type: 'all' | 'each' }>`
    display: flex;
    ${(props) =>
      props.type === 'each' &&
      css`
        width: 100%;
        display: flex;
        flex-flow: row nowrap;
        justify-content: space-between;
        padding: 0 14px;

        not:last-child {
          margin-bottom: 10px;
        }
      `}
    ${(props) =>
      props.type === 'all' &&
      css`
        padding: 12px 14px;
        border-radius: 12px;
        background: var(--black-4);
      `}
  `,

  FormCheckboxLabel: styled.label<{ type: 'all' | 'each' }>`
    ${(props) =>
      props.type === 'each' &&
      css`
        ${Noto_body2_r14};
      `}
    ${(props) =>
      props.type === 'all' &&
      css`
        ${Noto_body1_b16};
      `}
  color: var(--black-100);
    user-select: none;
    word-break: keep-all;
    display: flex;
    flex-flow: row;
    gap: 10px;
    align-items: flex-start;
  `,
  FormCheckbox: styled.input.attrs({ type: 'checkbox' })<{ $actColor?: string }>`
    position: relative;
    cursor: pointer;
    flex-shrink: 0;
    border: 1px solid var(--black-20);
    border-radius: 6px;
    width: 26px;
    height: 26px;
    background: var(--white);
    overflow: hidden;
    transition:
      background 0.3s ease,
      opacity 0.3s ease;
    &:checked {
      background: url(${checkboxBg}) no-repeat center/cover;
      background-color: ${(props) => props.$actColor || 'var(--brand-50)'};
      border: 0;
      opacity: 1;
    }
    &:not(:checked) {
      opacity: 0.5;
    }
  `,
  OtpRequestButton: ({
    backgroundColor,
    borderRadius,
    fontColor,
    fontSize,
    fontWeight,
    letterSpacing,
  }: {
    backgroundColor: string
    borderRadius: string
    fontColor: string
    fontSize: string
    fontWeight: number
    letterSpacing: string
  }) => css`
    background-color: ${backgroundColor || 'var(--brand-50)'};
    border-radius: ${borderRadius || '12px'};
    color: ${fontColor || 'var(--white)'};
    font-size: ${fontSize || '16px'};
    font-weight: ${fontWeight || 700};
    letter-spacing: ${letterSpacing || '0'};
    border: none;
    &:active {
      background-color: ${backgroundColor || 'var(--brand-50)'};
      opacity: 0.9;
    }
  `,
  JoinButton: ({
    backgroundColor,
    fontColor,
    fontSize,
    fontWeight,
    borderRadius,
    letterSpacing,
  }: {
    backgroundColor: string
    borderRadius: string
    fontColor: string
    fontSize: string
    fontWeight: number
    letterSpacing: string
  }) => css`
    background-color: ${backgroundColor || 'var(--brand-50)'};
    border-radius: ${borderRadius || '12px'};
    color: ${fontColor || 'var(--white)'};
    font-size: ${fontSize || '16px'};
    font-weight: ${fontWeight || 700};
    letter-spacing: ${letterSpacing || '0'};
    border: none;
    &:active {
      background-color: ${backgroundColor || 'var(--brand-50)'};
      opacity: 0.9;
    }
  `,
  CancelReset: ({
    backgroundColor,
    fontColor,
    fontSize,
    fontWeight,
    borderRadius,
    letterSpacing,
  }: {
    backgroundColor: string
    borderRadius: string
    fontColor: string
    fontSize: string
    fontWeight: number
    letterSpacing: string
  }) => css`
    background-color: ${backgroundColor || 'var(--brand-50)'};
    border: ${borderRadius !== '0px' ? '1px solid var(--black-10)' : 'none'};
    border-radius: ${borderRadius || '12px'};
    color: ${fontColor || 'var(--white)'};
    font-size: ${fontSize || '16px'};
    font-weight: ${fontWeight || 700};
    letter-spacing: ${letterSpacing || '0'};
  `,
}
